import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';

/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import IframeView from '@components/IframeView';

/* Constants */
import { PAGE_TYPE_CANCELLATION_POLICY } from '@constants/pages';

/* Exportable IFrame */
export const CancellationPolicyIframe = () => (
  <IframeView callerPageName="categorypage" src={`${process.env.NEXT_PUBLIC_WEBFLOW_CONTENTS_URL}cancellation-reschedule-policy`} />
);

function CancellationPolicy() {
  return (
    <>
      <Head>{generateNextSeo({ title: 'Cancellation Policy' })}</Head>
      <CancellationPolicyIframe />
    </>
  );
}

CancellationPolicy.pageAttributes = { page: PAGE_TYPE_CANCELLATION_POLICY };
CancellationPolicy.Layout = getLayout({ promo: false, footer: true });

export default CancellationPolicy;
